module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEXSURBVHgBxdaJDYMwDAXQqBMwCiMwQkdgBDaAzegG6QZhEzcf4iqlhdgOUi1FAmH7iSMhzv0jiOgex0xbhDhGZ4xYO6QeCB9Hn1/sQwjUdR3htG1b8h45ehA1qEUPnKIneuNmOMEzxKNpGjXIEGrzXuiNp8ZJHxct4BHEIxnr0cK3bQFLEHrjHXLycJZ8BpagrHbKiyYtaIIsYBWkBashDXgJJAUvgyxgFaQBpdDNCTwnD03urrLweTvlSnMJVAVKJqxlaTNBikk9VkP46ixrqQnKavRgzaKqAAcuCIKf5xckBfc/TzMkBZOxHs0nG54iVALThsdz0v1gKzc5ZTD4YyvX50l9HE/aYnm/UEOkqRFSrwelPeMLcBddSPcySvsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/android_close.png
// module id = qWJv
// module chunks = 0